export const ZohoDeskTicketPath = {
  ZohoDeskTicket: '/zoho-desk-ticket',
};

export default {
  ZohoDeskTicketPath,
};
